// extracted by mini-css-extract-plugin
export default {"slide__img":"carouselSlide_slide__img__YgC1f","slide__title-holder":"carouselSlide_slide__title-holder__JjfE+","slide__title":"carouselSlide_slide__title__kvQA4"};